module.exports = __webpack_public_path__ + "img/3_55.acbc3e58.png";